var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 75V125C25 128.315 26.317 131.495 28.6612 133.839C31.0054 136.183 34.1848 137.5 37.5 137.5H112.5C115.815 137.5 118.995 136.183 121.339 133.839C123.683 131.495 125 128.315 125 125V75M50 37.5L75 12.5L100 37.5M75 12.5V93.75",
    stroke: "#364152",
    strokeWidth: 12.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareDetail);
export default __webpack_public_path__ + "static/media/share-detail.209be055902e626d8a2bd844b0062030.svg";
export { ForwardRef as ReactComponent };